<template>
	<div class="payment-container">
		<div class="product-mask" v-show="showMask" @click="showMask=false">
			<div class="product-swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide" 
					v-for="(item,index) in order.imgArray" v-if="index<=3">
						<img :src="item.url">
					</div>
				</div>
			</div>
		</div>
		<div class="head">CHECKOUT</div>
		<div class="goods">
			<div class="item">

				<div class="goods-info">
					<div class="img">
						<img :src="order.thumb" alt="">
					</div>
					<div class="info">
						<p class="name">{{order.title}}</p>
						<p class="size"><em>Size:</em><span>{{order.code}}</span></p>
						<p class="num"><em>Num:</em><span>{{order.num}}</span></p>	
					</div>
				</div>
				<!-- <p class="price">${{order.price * order.num }}</p> -->
				<p class="price">$ {{order.price }}</p>
			</div>
			<div class="pro-wrap"  v-if="order.imgArray">
				<div class="img-item" v-for="(item,index) in order.imgArray"  @click="show(index)" >
					<img :src="item.url" />
				</div>
			</div>

			<div class="TIPS">Please final confirm with order list</div>

			<custable :order="order" :category="category"></custable>
		</div>

		<div class="address">
			<div class="form-title">
				<span>Delivery Address</span>
				<el-popover
				  placement="right"
				  :width="web?'300':width"
				  v-model="addressVisit"
				  trigger="click">

						<table class="addressTable">
						   
						   <tr v-for="item in addressList">
								<td>{{item.first_name}} {{item.last_name}}</td> 
								<td>{{item.country}}{{item.address}}</td> 
								<td>{{item.postcode}}</td> 
								<td align="right">
									<el-button type="success" round @click="chooseAddress(item)">Select</el-button>
								</td> 
						   </tr>
						</table>
				  <el-button slot="reference">Select Address</el-button>
				</el-popover>
			</div>
			<div id="form">
				<div class="form-item clearfix">
					<label class="form-label">First Name </label>
					<div class="input-block">
						<input class="input" type="text" v-model="formDate.first_name" placeholder="" autocomplete="on"/>
					</div>
				</div>
				<div class="form-item clearfix">
					<label class="form-label">Last Name</label>
					<div class="input-block">
						<input class="input" type="text" v-model="formDate.last_name" placeholder="" autocomplete="on"/>
					</div>
				</div>
				<div class="form-item clearfix">
					<label class="form-label">Mobile：</label>
					<div class="input-block">
						<input class="input" type="text" v-model="formDate.phone" placeholder="" autocomplete="on"/>
					</div>
				</div>
				<div class="form-item clearfix">
					<label class="form-label">Email</label>
					<div class="input-block">
						<input class="input" type="email" v-model="formDate.email" placeholder="" autocomplete="on"/>
					</div>
				</div>

				<div class="form-item clearfix" v-if="addressDate">
					<label class="form-label">Country:</label>
					
					<el-select v-model="formDate.country" placeholder="">
						<el-option :label="item.label" :value="item.value" :key="item.value" v-for="item in addressDate">
						</el-option>
					</el-select>

				</div>

				<div class="form-item clearfix">
					<label class="form-label">Address：</label>
					<div class="input-block">
						<input class="input" type="email" v-model="formDate.address" placeholder="Detailed info" autocomplete="on"/>
					</div>
				</div>
				<div class="form-item clearfix">
					<label class="form-label">Postcode:</label>
					<div class="input-block">
						<input class="input" type="text" v-model="formDate.postcode" placeholder="" autocomplete="on"/>
					</div>
				</div>
			</div>
		</div>
		<div class="payment-mode">
			<div class="title">Payment method</div>
			<div class="mode">

				<div class="item" :class="{'on': formDate.type == 5 }" @click="formDate.type=5">
					<img src="../../assets/pp.png">
				</div>
				<div class="item" :class="{'on': formDate.type == 7 }" @click="formDate.type=7" style="margin-left: 10px;">
					<img src="../../assets/stripe.png">
				</div>

			</div>
		</div>
		<div class="price-bottom">
				<ul>
					<li>
						<label>
							Unit price：
						</label>
						<span>$ {{order.price}}</span>
					</li>
					<li>
						<label>
							Num：
						</label>
						<span>{{order.num}}</span>
					</li>
					<li>
						<label>
							Actual payment：
						</label>
						<span class="red">$ {{order.price * order.num}}</span>
					</li>
				</ul>
		</div>
		<div class="btn-group">
			<el-button @click="confirm(false)">Add to Cart</el-button>
			<el-button @click="$router.go(-1)">Cancel</el-button>
			<el-button type="info" :loading="loading" @click="confirm(true)">Checkout</el-button>
			 
		</div>

	</div>
</template>

<script>
	
	import Swiper from 'swiper';
	
	import addressDate from '../../../static/address.json';

	import custable from "@/components/custable"

	import {
		mapState
	} from 'vuex';

	import {
		Dialog
	} from 'vant';


	export default {
		data() {
			return {
				orderList:[],
				addressDate:addressDate,
				category:[],
				formDate: {
					type: 5,
					country:addressDate[0].label,
				},
				gongyiprice:390,
				width:400,
				addressVisit:false,
				addressList:[],//已有地址
				loading:false,
				isProvince: false,
				paysuccess:false,
				alipayShow:true,
				showMask:false,
				swiper:null,
			}
		},
		components:{
		   custable,
		},
		computed: {
			...mapState({
				userInfo: state => state.userInfo,
				contact: state => state.contact,
				order: state => state.order,
				web: state => state.web,
			}),
		},
		watch:{
			$route(to,from){
				  console.log(to.path);
			}
		},
		mounted() {
			
			this.getUserInfo();


			this.category = this.order.category;


		},
		methods: {


			show(index) {
				this.showMask = true;
				if(this.swiper){
				   this.swiper.slideTo(index, 1000, false);
				}else{
					this.$nextTick(function() {
						this.swiper = new Swiper('.product-swiper-container', {
							autoplay: true,
							loop: true,
							initialSlide :index,
							slidesPerView: 'auto',
							// 如果需要分页器
							pagination: {
								el: '.swiper-pagination',
							},
						})	
					})
				}
			},
			
			chooseAddress(item){

				this.addressVisit = false;

				Object.assign(this.formDate, item);

			},
			checkPay(sn) {

				var app = this;

				this.$api("/pay/getPayStatus", {
					order_id: sn,
					user_id: app.$store.state.userInfo.id

				}).then(function(res) {

	

					if (res.status == "200") {
						app.$router.push("/productFinish?sn="+sn);
					}else{
						app.$router.push("/orderdetails/" + sn)
					}

				})
			},
			getOrderList() {

				var app = this;

				this.$api("/user/getOrderList", {
					page: 1,
					num: 1,
					status: 0
				}, "POST").then(function(res) {
					
					var sn  =  res.data.list[0].id

					if(app.web){
						Dialog.confirm({
						  title: 'Tips',
						  message: 'Please do not close this window when you checkout. After checkout, please click the button below according to your payment status.',
						  confirmButtonText:'Finish',
						  cancelButtonText: 'Failure to Pay',

						})
					.then(() => {
						app.checkPay(sn);
						  // app.$router.push("/productFinish?sn="+sn)
					})
					.catch(() => {
						   app.$router.push("/orderdetails/" + sn)
					});
				}else{
					app.$confirm('Please do not close this window when you checkout. After checkout, please click the button below according to your payment status.', 'Tips', {
					  confirmButtonText: 'Finish',
					  cancelButtonText: 'Failure to Pay',
					  type: 'warning',
					  center: true
					}).then(() => {
						app.checkPay(sn);
					   // app.$router.push("/productFinish?sn="+sn);
					}).catch(() => {
					   app.$router.push("/orderdetails/" + sn);
					});
				}

				})
			},
			getAddressList() {

				var app = this;

				this.$api("/user/getAddressList", {}).then(function(res) {

					 app.addressList = res.data.list;
					 
				})
			},
	
			weH5Pay(orderInfo){

				var app = this;

				orderInfo.embroidery.imageUrl = ""; //base64 清空掉；

				var emailReg=/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;

				var mobileReg = /^1[3|4|5|8][0-9]\d{4,8}$/;

				var postCodeReg  =  /^[1-9][0-9]{3,6}$/;


				if(!(orderInfo.phone)){ 
					app.global_variable.showWranToast("Phone doesn't exist");
					this.loading = false;
					return;
				}

				if(!emailReg.test(orderInfo.email)||!(orderInfo.email)){ 
					app.global_variable.showWranToast("Email doesn't exist");
					this.loading = false;
					return;
				}


				if(!(orderInfo.postcode)|| (orderInfo.postcode.length<4)|| orderInfo.postcode.length>8){
					app.global_variable.showWranToast("Postcode doesn't exist");
					this.loading = false;
					return;
				}

				



				app.$api("/order/index",orderInfo,"post").then(function(res) {

					app.loading = false;

					if (res.status == "200") {
						app.getOrderList();
						window.open(res.data.url);
					}
					if (res.status == "407") {
						app.global_variable.showToast("Added successfully");
						setTimeout(function(){
						   app.$router.push("/")
						},1000)	
					}


				})

			},
			getUserInfo() {
				var app = this;
				this.$api("/user/getUserInfo", {}).then(function(res) {
					if (res.status == "200") {

						app.getAddressList();
						
						app.$store.dispatch('SET_USER', res.data);
					}

				})
			},
			confirm(boolean) {

				var app = this;
				var orderMsg =  this.order;

				app.loading = boolean;
				if(boolean){
				   orderMsg.switch  = 1;
				}else{
				   orderMsg.switch  = 2;
				}
			   
				orderMsg.email    = this.formDate.email;
				orderMsg.phone    = this.formDate.phone;
				orderMsg.postcode    = this.formDate.postcode;
				orderMsg.pay_type = this.formDate.type;
				orderMsg.country  = this.formDate.country;
				orderMsg.first_name = this.formDate.first_name;
				orderMsg.last_name = this.formDate.last_name;
				orderMsg.address = this.formDate.address;

				this.weH5Pay(orderMsg)

			},
			inputFocus(name) {
				this[name] = true
			},
			inputBlur(name) {
				setTimeout(() => {
					this[name] = false
				}, 200)
			},

		}
	}
</script>

<style lang="less" >

	.TIPS{
		font-size:14px;
		font-weight: 700;
		color: #e82323;
		text-align:right;
	}
	.web-pay-wrap{
		.pay-item{
			display:flex;
			padding:10px 0;
			font-size:12px;
			justify-content: space-between;
			align-items:center;
			.pay-ways-selected{
				width:20px;
				height:20px;
				border:1px solid #000;
				border-radius:50%;
				img{
					width:20px;
					height:20px;
				}
			}
			img{
				width:30px;
				height:30px;
			}
		}
	}
	.payment-container {
		width: 900px;
		padding: 100px 0 243px;
		margin: 0 auto;
		.head {
			padding: 50px 0;
			border-bottom: 1px solid #e4e4e5;
			font-size: 34px;
			font-weight: bold;
			text-align: center;
		}
		.pro-wrap {
			display: flex;
			margin: 30px 0;
			.img-item {
				width: 24%;
				cursor: pointer;
				margin-right: 1%;

				img {
					width: 100%;
				}


				&:last-of-type {
					margin-right: 0;
				}
			}
		}
		 .price-bottom{
				margin-top: 50px;
				padding: 40px 70px;
				text-align: right;
				font-size: 16px;
				margin-bottom: 50px;
				background-color: #f7f8f8;
				ul{
					li{
						margin-bottom: 20px;
						color: #666;
						font-size: 16px;
						span{
							min-width: 100px;
							display: inline-block;
						}
						.red{
							font-weight: bold;
							color:#e82323;
						}
						&:last-of-type{
							margin-bottom: 0;
						}
					}
				}
			}
		

		.goods {
			 
			.item {
				padding: 54px 0 61px;
				border-bottom: 1px solid #f3f3f3;
				text-align: justify;
				text-align-last: justify;
				font-size: 0;

				.goods-info {
					text-align: left;
					text-align-last: left;
					vertical-align: middle;
					display: inline-block;

					.img {
						width: 200px;
						margin-right: 70px;
						vertical-align: middle;
						display: inline-block;

						img {
							width: 100%;
						}
					}

					.info {
						color: #0f0e0e;
						vertical-align: middle;
						display: inline-block;
						line-height:1.8;
						font-size: 16px;
						span {
							font-size: 14px;
						}
						em{
							margin-right:10px;
						}
						.name{
							width: 400px;
							margin-bottom:10px;
							font-size: 20px;
						}
					}
				}

				.price {
					text-align: left;
					text-align-last: left;
					font-size: 20px;
					line-height: 34px;
					vertical-align: middle;
					color: #0f0e0e;
					display: inline-block;
				}
			}
		}

		.address {
			padding: 48px 0 6px;
			.form-title {
				margin-bottom: 30px;
				display:flex;
				width:100%;
				align-items: center;
				justify-content: space-between;	
				
			}
		}

		.payment-mode {
			padding-bottom: 50px;
			border-bottom: 1px solid #dcdddd;

			.title {
				margin-bottom: 42px;
				font-size: 20px;
				font-weight: bold;
			}

			.mode {
				display: flex;
				align-items: center;

				.item {
					padding: 0 30px;
					line-height: 78px;
					border: 1px solid #dcdddd;
					border-radius: 6px;
					overflow: hidden;
					cursor: pointer;
				}

				.item.on {
					border-color: #90c31f;
				}

				
			}
		}
		.btn-group {
			display:flex;
			justify-content:flex-end;
			
		}
		#form {
			display:flex;
			flex-wrap:wrap;
			justify-content: space-between;
			.form-item {
				width: 48%;
				margin-bottom: 30px;
				border-radius: 6px;
				.el-select{
					width: 100%;
				}
			}
			.form-label {
				display:block;
				box-sizing: border-box;
				font-size: 16px;
				line-height: 50px;
				color: #666;
			}
			.form-inline {
				margin-right: 15px;
				border-radius: 6px;
				box-sizing: border-box;
				display: inline-block;
			}	
			.input-block {
				width: 100%;
				margin-top: -1px;
				padding-left:20px;
				border-radius:4px;
				overflow:hidden;
				border: 1px solid #e6e6e6;
				box-sizing: border-box;
			}

			.input {
				width: 100%;
				height: 40px;
				border: none;
				line-height:40px;
				border-radius: 6px;
				box-sizing: border-box;
				font-size: 14px;
				
				color: #333;
				background-color: #FFF;
				outline: none;
				display: block;
			}

			.select {
				padding-right: 30px;
				cursor: pointer;
			}

			.edge {
				position: absolute;
				right: 10px;
				top: 50%;
				margin-top: -8px;
				color: #1c305e;
				transition: all .3s;
				cursor: pointer;
			}

			.edge::before {
				content: '\e608';
			}

			.select-group {
				z-index: 899;
				position: absolute;
				left: 0;
				top: 55px;
				padding: 5px 0;
				min-width: 100%;
				border: 1px solid #d2d2d2;
				max-height: 200px;
				overflow-y: auto;
				background-color: #fff;
				border-radius: 2px;
				box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
				box-sizing: border-box;
				display: none;

				.select-tips {
					padding-left: 23px;
					font-size: 14px;
					line-height: 36px;
					cursor: pointer;
				}

				dd:hover {
					background-color: #f2f2f2;
					transition: .5s all;
				}

				dd.select-this {
					color: #FFF;
					background-color: #90c31f;
				}
			}

			.form-selected {
				.edge {
					transform: rotate(180deg);
				}

				.select-group {
					display: block;
				}
			}

			.clear-border {
				border-radius: 0px;
				border: none;
			}

			.submit {
				width: 140px;
				height: 40px;
				padding: 0;
				border: none;
				border-radius: 0;
				font-size: 16px;
				text-align: center;
				line-height: 40px;
				color: #FFF;
				background-color: #90c31f;
				cursor: pointer;
			}
		}
	}

	.product-mask {
		position: fixed;
		left: 0;
		z-index: 1000;
		top: 0;
		height: 100%;
		width: 100%;
		background-color: rgba(0, 0, 0, .5);

		.product-swiper-container {
			background-color:#fff;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%);
			position: relative;
			overflow: hidden;
			width: 800px;

			img {
				width: 100%;
			}

		}
	}

	@media screen and (max-width:768px) {
		.product-mask {
			position: fixed;
			left: 0;
			z-index: 1000;
			top: 0;
			height: 100%;
			width: 100%;
			background-color: rgba(0, 0, 0, .5);

			.product-swiper-container {
				top: 50%;
				left: 50%;
				transform: translateX(-50%) translateY(-50%);
				position: relative;
				overflow: hidden;
				width: 90%;
				img {
					width: 100%;
				}

			}
		}
	   .tableWrap{
			font-size:12px;
		}
	   .payment-container{
		  width:100%;
		  box-sizing:border-box;
		  padding:50px 4%;
		  .price-bottom{
			margin: 0px;
			padding: 4% 0;
			line-height:2;
			background-color:#fff;
			ul{
				li{
					margin-bottom:0;
					display:flex;

					font-size:12px;
					justify-content:flex-end;
				}
			}
		  }
		  .btn-group{
				border-top:1px solid #ebedf0;
				position: fixed;
				width: 100%;
				bottom:0;
				left:0;
				>button{
					flex:1;
					border-radius:0;
					border-left:none;
					border-bottom:none;
					font-size:12px;
					box-sizing:border-box;
					height:50px;
					margin:0;
					border-top-color:transparent;
				}
		  }
		  .payment-mode{
			
			padding-bottom:25px;
			.title{
				font-size:12px;
				margin-bottom:0;
				line-height:3;
			}
			.mode {
				.item{
					padding:10px;
					line-height:2;
					img{
						width:80px;
					}
				}
			}
			
		  }
		  #form {
			.select-group{
				top:40px;
			}
			.form-label{
				line-height:36px;
				height:36px;
				font-size:12px;
			}
			.input{
				height: 36px;
				font-size:12px;
				line-height:36px;
			}
			.form-inline{
				 width:100%;
				 margin-right: 0px;
				 margin-bottom:10px;
				 &:last-of-type{
					margin-bottom:0;
				 }
				.input-inline{
					width:calc(100% - 60px)
				}
			}
			.form-item{
				margin-bottom: 10px;

			}
		  }
		  .head{
			 padding-top:40px;
			 padding-bottom:17px;
			 font-size:17px;
		  }
		  .address{
			 padding:4% 0;
			 .form-title{
				margin-bottom:10px;
				font-size:14px;
				button{
					font-size: 14px;
					padding:6px 10px;
				}
			 }
			 .title{
				width:100%;
				margin-bottom:0;
				line-height:4;

				em{
					font-size:16px;
				}
				span{
					font-size:12px;
				}	
				
			 }
		   }

		  .goods{
			   font-size: 12px;
				
			   .item{
					padding:  4%  0;
					display:flex;
					align-items:center;
					.price{
						font-size:12px;
					}
					.goods-info {
						display:flex;
						align-items: center;
						.img{
							width:30%;
							margin-right:0;
						}
						.info {
						   padding-left:4%;
						   padding-right:1%;
						   flex:0 0 70%;
						   box-sizing:border-box;
						  .name{
							 width:100%;
							 font-size:12px;
							 margin-bottom: 0px;
						  }
						  
						}
					 }
					}
		  }
	   }
	}
	
</style>



// WEBPACK FOOTER //
// src/pages/payment/payment.vue